import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";

import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import CenteredContent from "../components/CenteredContent";

const useStyles = makeStyles((theme) => ({
  modify: {
    color: "gray",
  },
  leftImage: {
    height: 150,
  },
  rightImage: {
    height: 150,
  },
  link: {
    textDecoration: "none",
  },
  container: {
    marginTop: 40,
  },
}));

const ComparePage = (props) => {
  const { language } = useContext(LanguageContext);
  const classes = useStyles();

  let leftName = "";
  let rightName = "";
  let firstUni;
  let secondUni;

  const schools = localize("display.schools", language);

  const { state } = useLocation();
  try {
    const { data } = state;

    console.log(data);

    const firstUniIndex = data.firstUni[0];
    const firstUniCountry = data.firstUni[1];

    firstUni = schools[firstUniCountry][firstUniIndex];

    const secondUniIndex = data.secondUni[0];
    const secondUniCountry = data.secondUni[1];

    secondUni = schools[secondUniCountry][secondUniIndex];

    leftName = firstUni.name;
    rightName = secondUni.name;
  } catch (error) {
    console.log(error);
  }

  return (
    <Container className={classes.container} component="main" maxWidth="xl">
      <CenteredContent>
        <Grid container>
          <Grid item xs={6}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Link className={classes.link}>
                  <Typography align="center" className={classes.modify}>
                    {localize("compare.modify", language)}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <img
                  align="center"
                  className={classes.leftImage}
                  src={
                    firstUni
                      ? `${process.env.PUBLIC_URL}${firstUni.imageURL}`
                      : ``
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Link className={classes.link}>
                  <Typography align="center" className={classes.modify}>
                    {localize("compare.modify", language)}
                  </Typography>
                </Link>
              </Grid>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <img
                  align="center"
                  className={classes.rightImage}
                  src={
                    secondUni
                      ? `${process.env.PUBLIC_URL}${secondUni.imageURL}`
                      : ``
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <TableContainer component={Paper} style={{ marginTop: 30 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell width="40%" align="center">
                  {leftName}
                </TableCell>
                <TableCell width="20%"></TableCell>
                <TableCell width="40%" align="center">
                  {rightName}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell width="40%" align="center">
                  {firstUni.location}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#fdd997",
                    color: "#504538",
                    border: "1px solid #fdd997",
                  }}
                  align="center"
                >
                  {localize("display.location", language)}
                </TableCell>
                <TableCell width="40%" align="center">
                  {secondUni.location}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell width="40%" align="center">
                  {firstUni.price}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#ffd997",
                    color: "#504538",
                    border: "1px solid #ffc997",
                  }}
                  align="center"
                >
                  {localize("display.price", language)}
                </TableCell>
                <TableCell width="40%" align="center">
                  {secondUni.price}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell width="40%" align="center">
                  {firstUni.students}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#ffd997",
                    color: "#504538",
                    border: "1px solid #ffc997",
                  }}
                  align="center"
                >
                  {localize("display.students", language)}
                </TableCell>
                <TableCell width="40%" align="center">
                  {secondUni.students}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell width="40%" align="center">
                  {firstUni.level}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#ffd997",
                    color: "#504538",
                    border: "1px solid #ffc997",
                  }}
                  align="center"
                >
                  {localize("display.level", language)}
                </TableCell>
                <TableCell width="40%" align="center">
                  {secondUni.level}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell width="40%" align="center">
                  {firstUni.specialities.join(", ")}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#ffd997",
                    color: "#504538",
                    border: "1px solid #ffc997",
                  }}
                  align="center"
                >
                  {localize("display.speciality", language)}
                </TableCell>
                <TableCell width="40%" align="center">
                  {secondUni.specialities.join(", ")}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell width="40%" align="center">
                  {firstUni.credits.join(", ")}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#ffd997",
                    color: "#504538",
                    border: "1px solid #ffc997",
                  }}
                  align="center"
                >
                  {localize("display.credits", language)}
                </TableCell>
                <TableCell width="40%" align="center">
                  {secondUni.credits.join(", ")}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell width="40%" align="justify">
                  {firstUni.redTape}
                </TableCell>
                <TableCell
                  width="20%"
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#ffd997",
                    color: "#504538",
                    border: "1px solid #ffc997",
                  }}
                  align="center"
                >
                  {localize("display.redTape", language)}
                </TableCell>
                <TableCell width="40%" align="justify">
                  {secondUni.redTape}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CenteredContent>
    </Container>
  );
};

export default ComparePage;
